export enum StepTypeEnum {
    Quiz = 'quiz',
    QuizGeneral = 'quiz-general',
    QuizVariant = 'quiz-variants',
    IszGeneral = 'isz-general',
    IszVariant = 'isz-variants',
    Step = 'step',
    Menu = 'menu',
    Text = 'text',
    Certificate = 'certificate',
    Slider = 'slider',
    MediaContent = 'media-content',
}
